import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon'

@Pipe({
  name: 'isoStringToDate'
})
export class IsoStringToDatePipe implements PipeTransform {

  transform(value: string | null | undefined, mode: 'date' | 'datetime' = 'date'): string {
    if (!value) return '';

    const dt = DateTime
      .fromISO(value, { zone: 'utc' })       
      .setZone('Europe/Brussels');           

    if (!dt.isValid) return '';

    return mode === 'datetime'
      ? dt.toFormat('dd/MM/yyyy HH:mm')
      : dt.toFormat('dd/MM/yyyy');
  }

}
